var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.845 7.561-3.15-4.2a.52.52 0 0 0-.334-.202l-6.3-1.05a.5.5 0 0 0-.172 0l-6.3 1.05a.52.52 0 0 0-.334.202l-3.15 4.2c-.15.2-.138.48.03.666l9.45 10.5a.527.527 0 0 0 .78 0l9.45-10.5a.52.52 0 0 0 .03-.666m-6.42-.21-3.45 9.49-3.45-9.49zm-6.383-1.05L9.975 3.37 12.907 6.3zm4.463-2.887 3.882.647-1.294 1.941-2.59-2.588zM5.857 6.002 4.562 4.061l3.883-.647zm-.954.463-3.134.627 1.88-2.507zm.533.965 3.122 8.588L1.532 8.21zm9.078 0 3.904.781-7.027 7.808 3.123-8.588zm.532-.965 1.254-1.88 1.88 2.507z"
  })));
};
export default SvgDiamond;